import React from "react";
import { FlightDetailsFareUpgradeMobileUI } from "../../../../../../ui/FlightDetails/index.js";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { Stack } from "@bookingcom/bui-react";
export function UpgradeFareInfoMobile(props) {
    const { headerInline, fareInfoContent } = props;
    const i18n = useI18n();
    if (!fareInfoContent)
        return null;
    return (React.createElement(FlightDetailsFareUpgradeMobileUI, { header: i18n.trans(t("flights_fd_heading_fare_upgrades")), title: headerInline, content: (React.createElement(Stack, { gap: 0 }, [fareInfoContent.content, fareInfoContent.price].filter(Boolean).map((t, i) => (React.createElement(Stack.Item, { key: i }, t))))) }));
}
